// https://observablehq.com/d/1c427fdd7f170cd7@45
export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Point data attributes`
)});
  main.variable(observer("pointData")).define("pointData", function()
{
  return {"response":{"area":0,"layers":[{"name":"lri_rock_group","raster":false,"rows":[{"columns":[{"name":"INTERNAL_GEOMETRY_PK","value":13220},{"description":"General classification of rock type into broad lithological groups.","name":"Rock Group","value":"WI"},{"name":"Description","value":"Igneous Rocks – extremely weak to weak (e.g., tephras, breccias, scoria, pumiceous alluvium and lahars)                                                                                                                                                        "},{"description":"Principal basement lithology.","name":"Base Rock","value":"La "},{"description":"Principle lithology (i.e. not patchy) exposed at the surface, irrespective of any succeeding stratigraphy.","name":"Top Rock","value":"La "},{"description":"Lithology of the map unit beginning with the surface and/or dominant rock type and ending with the basement and/or least prominent rock type.","name":"Rock","value":"La                          "}],"number":1}]}],"poiType":"NotSmap","pointHeight":646.2369384765625,"region":"Taranaki"}}
}
);
  main.variable(observer("renderItem")).define("renderItem", ["html","DOM"], function(html,DOM){return(
(item) => html`<div class='report-attribute'><div class='report-attribute-title'>${DOM.text(item.name)}</div>
<div class='report-attribute-value'>${item.value}</div>
${item.description ? `<div class="report-attribute-description">${item.description}</div>` : ''}</div></div>`
)});
  main.variable(observer("attributeMarkup")).define("attributeMarkup", ["renderItem"], function(renderItem){return(
layer => {
  return layer.rows.map(row => {
    let items = row.columns
     .filter(c => c.name.indexOf('INTERNAL') !== 0)
     .filter(c => c.value !== undefined);
    return items.map(renderItem);
  }).reduce((acc, r) => acc.concat(r), [])
}
)});
  main.variable(observer("attributeList")).define("attributeList", ["pointData","attributeMarkup"], function(pointData,attributeMarkup)
{
  let items = pointData.response.layers.map(attributeMarkup).reduce((acc, l) => acc.concat(l),[])
    .reduce((acc, l) => acc.concat(l),[]);
  
  return items.length ? items : 'No data at this point.';
}
);
  main.variable(observer("report")).define("report", ["html","attributeList"], function(html,attributeList){return(
html`<div>${attributeList}</div>`
)});
  return main;
}
